import {
  ApplicationStatus,
  BookingStatus,
  ListingType,
  PriceUnit,
  RequirementType,
} from "../../../../Redux/ApiCalls/Dashboard/MarketplaceAPI";
export {
  APP_STATUS_COLOR,
  BOOKING_STATUS_BADGE_STYLES,
  LISTING_STATUS_BADGE_STYLES,
  LISTING_TYPE_BADGE_STYLES,
  LISTING_TYPE_COLORS,
  MARKETPLACE_COLORS,
  MARKETPLACE_GRADIENT,
  RECEIVED_APPLICATION_STATUS_STYLES,
  REQUIREMENT_STATUS_BADGE_STYLES,
  REQUIREMENT_TYPE_BADGE_STYLES,
  STATUS_COLOR,
  STATUS_COLORS,
  TYPE_COLORS,
} from "./marketplaceColors";

// Booking Status Mappings
export const STATUS_LABELS: Record<string, string> = {
  requested: "Inquiry",
  pending_payment: "Pending Payment",
  confirmed: "Confirmed",
  accepted: "Accepted",
  rejected: "Rejected",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const VALID_TRANSITIONS: Record<string, BookingStatus[]> = {
  requested: ["accepted", "rejected", "cancelled"],
  accepted: ["completed", "cancelled"],
  pending_payment: ["cancelled"],
  confirmed: ["completed", "cancelled"],
};

export const FILTER_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "requested", label: "Inquiries (Requested)" },
  { value: "pending_payment", label: "Pending Payment" },
  { value: "confirmed", label: "Confirmed" },
  { value: "accepted", label: "Accepted" },
  { value: "completed", label: "Completed" },
  { value: "rejected", label: "Rejected" },
  { value: "cancelled", label: "Cancelled" }
];

export const APP_STATUS_LABEL: Record<ApplicationStatus, string> = {
  pending: "Pending",
  accepted: "Accepted",
  rejected: "Rejected",
  withdrawn: "Withdrawn",
};

// Requirement Type Mappings
export const REQ_TYPE_LABEL: Record<string, string> = {
  equipment_requirement: "Equipment",
  service_requirement: "Service",
};

export const REQUIREMENT_TYPE_OPTIONS: {
  value: RequirementType;
  emoji: string;
  label: string;
  desc: string;
}[] = [
  {
    value: "equipment_requirement",
    emoji: "📷",
    label: "Equipment Requirement",
    desc: "Need a camera, lens, or gear",
  },
  {
    value: "service_requirement",
    emoji: "🎬",
    label: "Hire",
    desc: "Need a photographer or videographer",
  },
];

export const DEFAULT_REQUIREMENT_FORM = {
  requirement_type: "equipment_requirement" as RequirementType,
  title: "",
  description: "",
  location: "",
  date_from: "",
  date_to: "",
  budget: "",
  status: "active" as const,
};

export const REQUIREMENT_TYPE_DISPLAY_LABELS: Record<RequirementType, string> = {
  equipment_requirement: "📷 Equipment",
  service_requirement: "🎬 Service",
  bulk_custom_unit: "👥 Hire Teams",
};

// Listing Status and Type Mappings
export const LISTING_TYPE_LABELS: Record<ListingType, string> = {
  sale: "For Sale",
  rent: "For Rent",
  photographer: "Photographer",
  videographer: "Videographer",
};

export const LISTING_TYPE_DISPLAY_LABELS: Record<ListingType, string> = {
  rent: "🔑 Rent",
  sale: "📦 Sale",
  photographer: "📷 Photographer",
  videographer: "🎬 Videographer",
};

export const ORDER_LISTING_TYPE_LABELS: Record<string, string> = {
  sale: "Purchase",
  rent: "Rental",
  photographer: "Photographer Hire",
  videographer: "Videographer Hire",
};

export const ORDER_BOOKING_STATUS_LABELS: Record<string, string> = {
  requested: "Inquiry Sent",
  pending_payment: "Pending Payment",
  confirmed: "Confirmed",
  accepted: "Accepted",
  rejected: "Rejected",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const ORDER_APPLICATION_STATUS_LABELS: Record<string, string> = {
  pending: "Pending Review",
  accepted: "Accepted 🎉",
  rejected: "Not Selected",
  withdrawn: "Withdrawn",
};

export const ORDER_TIMELINE_STEPS: Record<string, number> = {
  requested: 1,
  pending_payment: 2,
  accepted: 3,
  confirmed: 3,
  completed: 4,
  rejected: -1,
  cancelled: -1,
};

export const RECEIVED_APPLICATION_STATUS_LABELS: Record<ApplicationStatus, string> = {
  pending: "Pending",
  accepted: "Accepted",
  rejected: "Rejected",
  withdrawn: "Withdrawn",
};

export const RECEIVED_APPLICATION_STATUS_TABS: { value: ApplicationStatus | ""; label: string }[] = [
  { value: "", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "accepted", label: "Accepted" },
  { value: "rejected", label: "Rejected" },
  { value: "withdrawn", label: "Withdrawn" },
];

export const PRICE_UNIT_LABELS: Record<PriceUnit, string> = {
  fixed: "fixed",
  per_day: "/day",
  per_hour: "/hr",
  negotiable: "negotiable",
};
